/**
 * Single chokepoint for all GA4/GTM dataLayer writes. Nothing else in this
 * codebase should call dataLayer.push directly.
 */
export function pushGAEvent(eventName, payload, userData = {}) {
    window.dataLayer = window.dataLayer || [];
    // Pushed as its own dataLayer entry, separate from `ecommerce` below, for GTM
    // tags/variables that key off a top-level `user_data` (see
    // GAPayloadBuilder::userDataPayload()). Skipped entirely when empty (e.g. a
    // fresh checkout page before the guest has typed anything) rather than
    // pushing a pointless empty object.
    if (userData && Object.keys(userData).length > 0) {
        window.dataLayer.push({ user_data: userData });
    }
    // Reset before every ecommerce push (Google's own recommended pattern) so a
    // previous event's items[]/other keys can't bleed into this one via GTM's
    // object-merge behavior.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce: payload });
}

// Exposed for the one legitimate direct caller outside the Livewire bridge below:
// BookingController::success() renders a plain Blade view (no Livewire component),
// so it inlines a <script> that calls this directly.
window.pushGAEvent = pushGAEvent;

/**
 * Bridges PHP-side `$this->dispatch('ga-event', event: ..., payload: ..., userData: ...)`
 * calls (see App\Livewire\Concerns\DispatchesGAEvents) to the dataLayer push above.
 * Registered once, on Livewire's own init event.
 */
export function initGAListener() {
    Livewire.on('ga-event', ({ eventName, payload, userData }) => pushGAEvent(eventName, payload, userData));
}
